// extracted by mini-css-extract-plugin
module.exports = {"bg":"style__bg__4duNe","logo":"style__logo__PgcIE"};